import React from "react"
import { Alert } from "../components/Core/pageBase"
import { ALERT_HEIGHT } from "@capioweb/ui-components"
import { ChildrenProps } from "../@types/CapioWeb/core"

export interface PageAlerts {
	common: Alert[]
	local: Alert[]
}

export interface UIContextValue {
	primaryMobileMenuOpen: boolean
	togglePrimaryMobileMenuOpen: () => void
	pageAlerts?: Record<"common" | "local", Alert[]>
	setPageAlerts: React.Dispatch<React.SetStateAction<PageAlerts>>
	pageAlertsHeight?: number
	alternateHeaderLayout: boolean
	setAlternateHeaderLayout: React.Dispatch<React.SetStateAction<boolean>>
}

export const UIContext = React.createContext<UIContextValue>({
	primaryMobileMenuOpen: false,
	togglePrimaryMobileMenuOpen: () => { },
	pageAlerts: null,
	setPageAlerts: () => { },
	pageAlertsHeight: null,
	alternateHeaderLayout: false,
	setAlternateHeaderLayout: () => false,
})

export const UIContextProvider: React.FC<ChildrenProps> = (props) => {
	const [primaryMobileMenuOpen, setPrimaryMobileMenuOpen] =
		React.useState(false)

	const [pageAlerts, setPageAlerts] = React.useState<PageAlerts>(null)
	const [pageAlertsHeight, setPageAlertsHeight] = React.useState(0)
	const [alternateHeaderLayout, setAlternateHeaderLayout] = React.useState(false)

	/* Used to calculate offsets in header and mega menu */
	const togglePrimaryMobileMenuOpen = () =>
		setPrimaryMobileMenuOpen((prev) => !prev)

	/*
		Calculate number off and total height for page alerts.
		Used for offsets and placement
	*/
	React.useEffect(() => {
		let h = 0
		if (pageAlerts) {
			for (const [key, value] of Object.entries(pageAlerts)) {
				if (value.length > 0) h += ALERT_HEIGHT
			}

			setPageAlertsHeight(h)
		}
	}, [pageAlerts])

	return (
		<UIContext.Provider
			value={{
				primaryMobileMenuOpen,
				togglePrimaryMobileMenuOpen,
				pageAlerts,
				setPageAlerts,
				pageAlertsHeight,
				alternateHeaderLayout,
				setAlternateHeaderLayout,
			}}
		>
			{props.children}
		</UIContext.Provider>
	)
}
